import React from "react";
import { Link } from "react-router-dom";
import AnimatedSection from "../animation/AnimatedSection"; // Make sure this component exists
import "./Aboutus.css";
import founderimg from "../images/founder.jpg"
import ceoimg from "../images/ceo.jpg"
const Founder = () => {
  return (
    <>
      {/* <header className="bg-danger text-white py-5 px-4">
        <div className="container-fluid">
          <nav className="d-flex align-items-center gap-2 small">
            <i className="fas fa-home"></i>
            <Link to="/" className="text-white text-decoration-underline">Home</Link>
            <span>/</span>
            <Link to="/about" className="text-white text-decoration-underline">About Us</Link>
            <span>/</span>
            <span>Our Founder</span>
          </nav>
        </div>
      </header> */}
      <div className="title-section-about">
        <p className="small-text-about">Learn More </p>
        <h1>
          About <span>us</span>
        </h1>
        <Link to="/" className="Link">Home</Link>
        <span>/</span>
        <span>About Us</span>
      </div>

      <main>
        <AnimatedSection>
          <div className="container-fluid py-2 bg-light text-center">
            <h2 className="fw-semibold text-dark mb-4">Explore More</h2>
            <div className="d-flex justify-content-center flex-wrap gap-3">
              <Link to="/aboutus" className="btn btn-outline-dark btn-lg px-5">
                What we do?
              </Link>
              <Link to="/founder" className="btn btn-danger btn-lg px-5" aria-current="page">
                Meet Our Founder
              </Link>
            </div>
            {/* Founder & Team Section with individual animations */}
            <div className="container-fluid bg-light py-2">
              <AnimatedSection>
                <h2 className="fw-semibold display-6 text-dark text-center mb-4">Our Founder &amp; Team</h2>
                <div className="d-flex justify-content-center align-items-center mb-5">
                  <div style={{ width: "2rem", height: "2px", backgroundColor: "#a71d2a" }}></div>
                  <div className="d-flex mx-2" style={{ gap: "0.25rem" }}>
                    <div style={{ width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#a71d2a" }}></div>
                    <div style={{ width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#a71d2a" }}></div>
                    <div style={{ width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#a71d2a" }}></div>
                  </div>
                  <div style={{ width: "2rem", height: "2px", backgroundColor: "#a71d2a" }}></div>
                </div>
              </AnimatedSection>

              <div className="row justify-content-center g-3 px-3">
                <div className="col-12 col-md-4 text-center">
                  <AnimatedSection animationType="slideRight">
                    <img src={founderimg} 
                    alt="Shri.V.Nallappan" className="img-fluid border rounded shadow" style={{ height: "300px", width: "230px", objectFit: "cover" }} />
                    <h4 className="mt-4 fw-semibold text-dark">Shri.V.Nallappan</h4>
                    <p className="text-muted">Founder</p>
                  </AnimatedSection>
                </div>
                <div className="col-12 col-md-4 text-center">
                  <AnimatedSection animationType="slideLeft">
                    <img src={ceoimg} alt="Sriarun Loganathan" className="img-fluid border rounded shadow" style={{ height: "300px", width: "230px", objectFit: "cover" }} />
                    <h4 className="mt-4 fw-semibold text-dark">Sriarun Loganathan</h4>
                    <p className="text-muted">Managing Director</p>
                  </AnimatedSection>
                </div>
              </div>
            </div>

            {/* Animated Bio Section */}
            <AnimatedSection>
              <div className="container-fluid py-5">
                <div className="mx-auto text-start px-3" style={{ maxWidth: "1200px" }}>
                  <h3>About the Founder</h3>
                  <p className="fs-6 lh-lg mb-4">During the scorching summer of 1940’s a young man from an agricultural family in a small village in the Namakkal district of South India responded to the call of the national leaders to fight for the freedom of the Nation. The young man was held by the British and imprisoned. His patriotism influenced others around 
                    him and became a leader for the Namakkal district of Indian National Congress. The man was none other than Shri.V.Nallappan and he is been called us “Good Father”. </p>
                  <p className="fs-6 lh-lg mb-4">Post-independence, Shri.V.Nallappan decided to contribute to build the nation with the vision to generate jobs for the local youth. He began his career as a help in a small shop and through his hard work and continuous learning became an entrepreneur in 1960’s. He diversified his business spanning from Transport Business to Movie Theatres and worked hard and contributed for about 4 decades to building a strong society until his demise in the year 2000.</p>
                  <h3>About the Managing Director</h3>
                  <p className="fs-6 lh-lg mb-4">Having born into such a proud family that fought for the Freedom of the country,
                     Sriarun Loganathan the grandson of late Shri.V.Nallappan, has the same patriotism and the vision to contribute to the growth of the country, 
                     started CIRA Technology Pvt Ltd.</p>
                     <p className="fs-6 lh-lg mb-4">He is an Electrical Engineer with an MBA, having over 25 years of significant knowledge across industrial verticals such as Oil & Gas, Petrochemicals, Power, Sugar, Pulp & Paper, Metals & Mining, Automotive, Water Management (ETP,STP,WTP).</p>
                     <p className="fs-6 lh-lg mb-4">Having 17years of working experiences with Global Industrial giants like ABB India Ltd, Honeywell Automation, Rockwell Automation, Forbes Marshall, across functions spanning Sales, Marketing, BD, Product Management and acquired the leadership ability to combine Technical and Business Tools to address various industrial challenges.</p>
                     <h3>About the Director</h3>
                      <p className="fs-6 lh-lg mb-4">Dr.Subathradevi Sriarun, an Engineer with the Doctorate degree, having 17yrs of working experience as a HOD & Professor, handled many Management Roles, additionally ISO/NAAC/NBA council in Kongu Engineering College & Saveetha University. The leadership quality and the spirit to work as a team, made her as Operations Director.</p>
                </div>
              </div>
            </AnimatedSection>

            {/* Animated Explore More Section */}

          </div>
        </AnimatedSection>
      </main>
    </>
  );
};

export default Founder;
